import registerUser from '~/gql/register/createUser.gql'
import verifyUser from '~/gql/register/verifyUser.gql'

export default {
  registerUser,
  verifyUser
}
